import { render, staticRenderFns } from "./dialog-plus.vue?vue&type=template&id=4e61ce6e"
import script from "./dialog-plus.vue?vue&type=script&lang=js"
export * from "./dialog-plus.vue?vue&type=script&lang=js"
import style0 from "./dialog-plus.vue?vue&type=style&index=0&id=4e61ce6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports